// @flow

// #region imports
import React from 'react';
import TabList from './TabList'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import { bindActionCreators } from 'redux';
import { getRewardDetail } from '../action';
import queryString from 'query-string';
import { firstQueryValue } from 'shared/util/queryParams';


// #endregion
class Reward extends React.Component {
  componentDidMount(){
    const { location } = this.props;
    const parsed = queryString.parse(location.search);
    const rewardUrl = firstQueryValue(parsed.url);
    const uid = firstQueryValue(parsed.uid);
    if (!rewardUrl || String(rewardUrl).trim() === '') {
      return;
    }
    const p = this.props.getRewardDetail(rewardUrl, uid);
    if (p != null && typeof p.then === 'function') {
      p.catch(() => {});
    }
  }

  render() {
    const parsed = queryString.parse(this.props.location.search);
    const urlUid = firstQueryValue(parsed.uid);
    const listUserKey =
      (this.props.rewardListUserKey && String(this.props.rewardListUserKey).trim() !== ""
        ? this.props.rewardListUserKey
        : urlUid) || "";
    return (
      <div className="Card-container overflowY">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
            <div className="card card-shadow-NA">
             
              <div className="card-body rewardCard">
                {/* <div className="cart-header"> */}
                  <div className="flex-row">
                    <div className="card-text F3">Claim It</div>
                    <div className="card-text F3">Earned</div>
                    <div className="card-text F3">Paid</div>
                  </div>

                  <div className="flex-row" style={{padding:'4px 0px 10px'}}>
                    <div className="card-text F1 Fw Lh-2">₹ {this.props.availablePoints }</div>
                    <div className="card-text F1 Fw Lh-2">₹ {this.props.totalReward}</div>
                    <div className="card-text F1 Fw Lh-2">₹ {this.props.maintenancePaid}</div>
                  </div>

                  <div className="card-text F3">Earn {this.props.remainingPoints + ' '} more points needed to decreses your maintenance</div>
                {/* </div> */}
              </div>

              <TabList uid={listUserKey} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    maintenancePaid:state.reward.maintenancePaid,
    remainingPoints:state.reward.remainingPoints,
    availablePoints:state.reward.availablePoints,
    totalReward:state.reward.totalReward,
    rewardListUserKey: state.reward.rewardListUserKey,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRewardDetail,
    },
    dispatch
  );


// #endregion

export default compose(
  connect(mapStateToProps, mapDispatchToProps),withRouter
)(Reward);
